import React, { useState } from 'react'
import { Tabs, Card, Button } from 'antd';
import AccessibilityAndSecurityDetail from './AccessibilityAndSecurityDetail'
import AccessibilityAndSecurityEdit from './AccessibilityAndSecurityEdit'
import PageContainer from '../../../CSIComponents/PageContainer';
const { TabPane } = Tabs;

interface propsTypes {
    isEditable?: void | any,
    cancelEditable?: void | any,
    disableTabPanes?: void | any,
    detail?: any,
    cancelAndSave?: void | any,
    tableCurrentData?: any,
    scheduleAndChargeData?: void | any,
    editData?:void|any,
    handelCancelBtnClick?:void|any,
    setDisabledFlag?:any

}
const AccessibilityAndSecurity = (props: propsTypes) => {
    const [editFlag, setEditFlag] = useState(false);
    //const [accessibilityAndSecurityEditFlag, setAccessibilityAndSecurityEditFlag] = useState<any>(false)
    //const [disabledFlag, setDisabledFlag] = useState<any>(false)
    
    const edit = () => {
        return <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <div style={{margin: '0 10px 0 0'}}>
                        <Button className="db-edit-btn" onClick={() => { props.cancelAndSave(); }}>Back</Button>
                    </div>
                    <div>
                        <Button className='db-edit-btn' type='primary' onClick={() => { setEditFlag(!editFlag); props.isEditable(); props.setDisabledFlag(true) }}>Edit</Button>
                    </div>
                </div>
    }

    const saveAndCancel = <>
        <Button type='primary' style={{ background: '#dc3545', borderColor: '#dc3545' }} onClick={() => {
            setEditFlag(!editFlag);
            props.cancelEditable(); 
            //setDisabledFlag(false) 
        }}>Cancel</Button>
         <Button type='primary' onClick={() => { setEditFlag(!editFlag) }} style={{ marginLeft: 10 }}>Save</Button>
     </>
     const setEditToDetail = ()=>{
        setEditFlag(false);
        setEditFlag(!editFlag); 
        props.cancelEditable(); 
        //setDisabledFlag(false)
     }
     const [detailInfo,setDetailInfo] = useState(props.scheduleAndChargeData.details);
     //TODO 编辑成功以后到详情页表面并重置数据
     const resetDetailInfo = (data:any) =>{
        setDetailInfo(data)
     }
    return(
        <>
            {!editFlag?
             <PageContainer>
                 <Card style={{marginBottom:'60px'}}><Tabs defaultActiveKey='0' type="card" tabBarExtraContent={editFlag ? saveAndCancel : edit()}>
                {detailInfo.map((item: any, index: any) => {
                    return (

                        <TabPane tab={'Detail ' + (index + 1)} key={index}>
                            <Card>
                                <AccessibilityAndSecurityDetail detailData={item}  />
                            </Card>
                        </TabPane>
                    )

                })}
            </Tabs></Card></PageContainer>:<AccessibilityAndSecurityEdit cancelAndSave = {props.cancelAndSave} setDisabledFlag = {props.setDisabledFlag} resetDetailInfo = {resetDetailInfo} setEditToDetail = {setEditToDetail} idInfo = {props.scheduleAndChargeData} editData={detailInfo}/>}
        </>
    )
}

export default AccessibilityAndSecurity;

